import { render } from "./EditNotice.vue?vue&type=template&id=31b75642&scoped=true"
import script from "./EditNotice.vue?vue&type=script&lang=js"
export * from "./EditNotice.vue?vue&type=script&lang=js"

import "./EditNotice.vue?vue&type=style&index=0&id=31b75642&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b75642"]])

export default __exports__